var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(_vm.component, {
        tag: "component",
        attrs: {
          popupParam: _vm.popupParam,
          contentHeight: _vm.contentHeight,
          count: _vm.count,
        },
        on: {
          closePopup: _vm.closePopup,
          changeStatus: _vm.changeStatus,
          transInfo: _vm.transInfo,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }